import React from "react";
import styles from "./index.module.css";
import AsyncSelect from "react-select/async";
import { components } from "react-select";

const SelectSearch = ({
  id,
  label,
  subLabel = null,
  required = false,
  ...selectProps
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "3.6rem",
      height: "3.6rem",
      padding: "0",
      fontSize: "1.6rem",
      fontFamily: "Arial",
      outline: "none",
      border: "1px solid var(--border-color)",

      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      borderColor: state.isFocused ? "none" : provided.borderColor,
      "&:hover": {
        borderColor: "#ccc",
        backgroundColor: "transparent",
      },
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      fontSize: "1.6rem",
      fontFamily: "Arial",
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "3.6rem",
      padding: "0 8px",
      fontSize: "1.6rem",
      fontFamily: "Arial",
      borderColor: state.isFocused ? "none" : provided.borderColor,
    }),
    menu: (provided) => ({
      ...provided,
      // maxHeight: '10rem',
      fontSize: "1.6rem",
      fontFamily: "Arial",
    }),
    option: (provided) => ({
      ...provided,
      padding: "10px",
      fontSize: "1.6rem",
      fontFamily: "Arial",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0px", // Change the padding here
      paddingRight: "1rem",
      // You can also customize other properties like color, margin, etc.
    }),
     placeholder: (provided) => ({
    ...provided,
    fontSize: "1.2rem",
    fontFamily: "Arial",
    color: "#999", 
  }),
  };

  const CustomDropdownIndicator = React.useCallback((props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5 7.5L10 12.5L15 7.5" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </components.DropdownIndicator>
    );
  }, []);
  return (
    <div
      className={styles.formGroup}
      style={selectProps.formGroupStyleOverride}
    >
      {label && (
        <label htmlFor={id}>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      {subLabel && <label className={styles.subLabel}>{subLabel}</label>}
      <AsyncSelect
        backspaceRemovesValue={true}
        {...selectProps}
        defaultOptions={true}
        required
        styles={customStyles}
        isClearable
        components={{ DropdownIndicator: CustomDropdownIndicator }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default SelectSearch;
